import React, { useContext, useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import DispatchContext from "../../contexts/DispatchContext";
import LoadingIndicator from "../elements/LoadingIndicator";
import FormTextsImprint from "../forms/FormTextsImprint";
import FormTextsContact from "../forms/FormTextsContact";
import FormTextsPrivacy from "../forms/FormTextsPrivacy";

import DataFetcher from "../../utils/DataFetcher";
import { getResponse, dispError, dispSuccess } from "../../utils/Tools";
import { merge as mergeObjects } from "lodash";

function Texts(props) {
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();

  const segments = [
    { id: "imprint", label: "Impressum" },
    { id: "contact", label: "Kontakt" },
    { id: "privacy", label: "Datenschutz" }
  ];

  const [formdata, setFormData] = useState(null);
  const [current, setCurrent] = useState(segments[0].id);

  const btnClass = "button is-medium";

  const loadData = useCallback(() => {
    DataFetcher.fetch(DataFetcher.CLIENT.GET_TEXTS)
      .then(response => {
        if (!response.success) return appDispatch(dispError(response.msg));
        setFormData(response.formdata);
      })
      .catch(error => {
        console.error(error);
      });
  }, [appDispatch, setFormData]);

  useEffect(() => {
    if (!formdata) loadData();
  }, [loadData, formdata]);

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  const updateData = async (segment, data) => {
    let injection = {};
    injection[segment] = data;
    let payload = { formdata: mergeObjects(formdata, injection) };
    try {
      const response = await DataFetcher.fetch(DataFetcher.CLIENT.SET_TEXTS, payload);
      if (!response.success) {
        appDispatch(dispError(response.msg));
        return { success: false };
      }
      appDispatch(dispSuccess(getResponse("014")));
      setFormData(response.formdata);
      return {
        success: true,
        data: response.formdata[segment]
      };
    } catch (error) {
      console.error(error);
      appDispatch(dispError(getResponse("015")));
      return { success: false };
    }
  };

  return (
    <main className="texts">
      <h1 className="title">Textverwaltung</h1>
      <p>
        Im Bereich „Textverwaltung“ pflegen Sie die rechtlichen Inhalte Ihrer Subdomain.
        <br />
        Darunter fallen Angaben im Impressum, im Kontakt wie auch in der Datenschutzerklärung.
      </p>

      <div className="field has-addons">
        {segments.map((segment, index) => {
          return (
            <p className="control" key={`btn-current-${index}`}>
              <button
                className={`${btnClass}${current === segment.id ? " is-info" : ""}`}
                onClick={() => {
                  setCurrent(segment.id);
                }}>
                <span>{segment.label}</span>
              </button>
            </p>
          );
        })}
      </div>

      {!formdata && <LoadingIndicator />}
      {formdata && current === "imprint" && (
        <FormTextsImprint
          data={formdata.imprint}
          onCancel={e => {
            history.push("/");
          }}
          onSubmit={updateData}
        />
      )}
      {formdata && current === "contact" && (
        <FormTextsContact
          data={formdata.contact}
          onCancel={e => {
            history.push("/");
          }}
          onSubmit={updateData}
        />
      )}
      {formdata && current === "privacy" && (
        <FormTextsPrivacy
          data={formdata.privacy}
          onCancel={e => {
            history.push("/");
          }}
          onSubmit={updateData}
        />
      )}
    </main>
  );
}
export default Texts;
